import { NativeError, RuntimeError } from '@belimo-retrofit-portal/logic';
import { SagaIterator } from 'redux-saga';
import { PROJECT_LIST_COLUMN_LIST } from 'src/modules/project-list/codecs/ProjectListColumn';
import { PROJECT_LIST_COLUMNS_VERSION } from 'src/modules/project-list/constants/columns';
import { ProjectListColumn } from 'src/modules/project-list/types/ProjectListColumn';
import { storageSet } from 'src/sagas/utils/storage';
import { call } from 'typed-redux-saga';

export function* saveProjectListColumns(columns: ReadonlyArray<ProjectListColumn>): SagaIterator<void> {
  try {
    const raw = yield* call(PROJECT_LIST_COLUMN_LIST.encode, columns);
    yield* call(storageSet, `project-list-columns-${PROJECT_LIST_COLUMNS_VERSION}`, raw);
  } catch (error) {
    throw new RuntimeError('Could not save project list columns', { columns }, NativeError.wrap(error));
  }
}
